import enUS from "./en-US";

export const messages = {
  "en-US": enUS,
};

export const SUPPORTED_LOCALES = Object.keys(messages);
export const DEFAULT_LOCALE = "en-US";
